import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  // mode: 'hash',
  routes: [
    {
      path: "/",
      name: "index",
      component: (resolve) => require(["../pages/index/index.vue"], resolve),
    },
    {
      path: "/about",
      name: "about",
      component: (resolve) => require(["../pages/about.vue"], resolve),
    },
    {
      path: "/attract",
      name: "attract",
      component: (resolve) => require(["../pages/attract.vue"], resolve),
    },
    {
      path: "/customized",
      name: "customized",
      component: (resolve) => require(["../pages/customized.vue"], resolve),
    },
    {
      path: "/goods",
      name: "goods",
      component: (resolve) => require(["../pages/goods.vue"], resolve),
    },
    {
      path: "/buy",
      name: "buy",
      component: (resolve) => require(["../pages/buy.vue"], resolve),
    },
    {
      path: "/service",
      name: "service",
      component: (resolve) => require(["../pages/service.vue"], resolve),
    },
    {
      path: "/anli",
      name: "anli",
      component: (resolve) => require(["../pages/anli.vue"], resolve),
    },
    {
      path: "/concat",
      name: "concat",
      component: (resolve) => require(["../pages/concat.vue"], resolve),
    },
    {
      path: "/Dynamic",
      name: "Dynamic",
      component: (resolve) => require(["../components/Dynamic.vue"], resolve),
    },
    {
      path: "/anDetail",
      name: "anDetail",
      component: (resolve) => require(["../pages/anDetail.vue"], resolve),
    },
    {
      path: "/Detail",
      name: "Detail",
      component: (resolve) => require(["../components/Detail.vue"], resolve),
    },
    {
      path: "/map",
      name: "map",
      component: (resolve) => require(["../pages/map.vue"], resolve),
    },
  ],
});
